export default (string) => string || "-";
